import { Component, OnInit, Inject } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { TamasAlunoService } from "../tamas-aluno.service";
import { AlertaSimplesDialog } from "../alerta-simples";
import { AlertaInputDialog } from "../alerta-input";
import * as moment from "moment";
import { ChangeDetectorRef } from "@angular/core";
import { Observable } from "rxjs";
import {
  MatBottomSheet,
  MatBottomSheetRef,
  MAT_BOTTOM_SHEET_DATA,
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material";
import { Configuracoes } from "../tamas-models";
import { AlertaConfirmDialog } from "../alerta-confirm";

@Component({
  selector: "app-me-configuracoes",
  templateUrl: "./me-configuracoes.component.html",
  styleUrls: ["./me-configuracoes.component.css"],
})
export class MeConfiguracoesComponent implements OnInit {
  hideCL: boolean = false;
  meuNome: any = "";
  meuNick: any = "";
  dataNascimento: any = "";
  altura: any = "";
  peso: any = "";
  meuLocal: any = "";
  minhaFoto: any = "";
  meuCelular: any = "";
  minhaFrase: any = "";
  urlFoto: any = "";
  //minhasPreferencias: Configuracoes[] = [];
  minhasPreferencias: Configuracoes = new Configuracoes();
  nomeDieta: any = "";
  nomeTreino: any = "";
  isDarkTheme: Observable<boolean>;
  mBottomCfg: any;
  userAsPro: boolean = false;
  avoidP: boolean = true;
  constructor(
    private route: ActivatedRoute,
    private _location: Location,
    public router: Router,
    public tmaService: TamasAlunoService,
    public dialog: MatDialog,
    private bottomSheet: MatBottomSheet
  ) {}
  ngOnInit() {
    if (this.tmaService.hcWA && this.tmaService.hcSO == "ios") {
      this.avoidP = true;
    } else {
      this.avoidP = false;
    }
    console.log(this.avoidP);
    this.isDarkTheme = this.tmaService.isDarkTheme;
    this.obterPreferencias();
    setTimeout(() => {}, 2000);
  }

  obterPreferencias(): void {
    //this.minhasPreferencias = [];
    this.hideCL = false;
    var dadosIn =
      "email=" + this.tmaService.hcEmail + "&senha=" + this.tmaService.hcSenha;
    this.tmaService.listarUserCfg(dadosIn).subscribe((qRes) => {
      console.log(qRes);
      if (qRes["res"] == "done") {
        if (this.tmaService.hcIsPro) {
          this.userAsPro = true;
        }
        this.minhasPreferencias = qRes["prefUsuario"];
        this.nomeDieta = qRes["nomeDieta"];
        this.nomeTreino = qRes["nomeTreino"];
        if (this.minhasPreferencias["ViewMode"] == "light") {
          this.tmaService.setDarkTheme(false);
          this.isDarkTheme = this.tmaService.isDarkTheme;
        } else {
          this.tmaService.setDarkTheme(true);
          this.isDarkTheme = this.tmaService.isDarkTheme;
        }
      }
      this.hideCL = true;
    });
  }

  toggleDarkTheme(checked: boolean) {
    console.log("foi");
    this.tmaService.setDarkTheme(checked);
    //enviar para servidor
    if (checked) {
      this.salvarPref("tema", "dark");
    } else {
      this.salvarPref("tema", "light");
    }
  }

  changeTP(qValor: any): void {
    console.log(qValor);
    this.userAsPro = !qValor;
    if (this.userAsPro) {
      //true show bottom
      this.mBottomCfg = this.bottomSheet.open(BottomSheetOverviewCfg, {
        data: { TP: true },
      });
      this.mBottomCfg.afterDismissed().subscribe((res) => {
        console.log("bottom dismiss");
        console.log(res);
        if (res != undefined) {
          if (res != "") {
            //existem profissoes
            var qProfissoes = res.substring(0, res.lastIndexOf(","));
            let customParams = {
              //lista: localStorage.getItem('turboCart'),
              email: this.tmaService.hcEmail,
              senha: this.tmaService.hcSenha,
              profissional: true,
              profissoes: qProfissoes,
            };
            this.hideCL = false;
            this.tmaService.editarTipoPerifl(customParams).subscribe(
              (qRes) => {
                this.hideCL = true;
                console.log(qRes);
                if (qRes["res"] == "done") {
                  this.tmaService.hcIsPro = true;
                  const perfilChan = this.dialog.open(AlertaSimplesDialog, {
                    disableClose: true,
                    data: {
                      textoAlerta:
                        "Tipo de Perfil atualizado com sucesso! Volte para a home e terá um atalho para <b>Área Profissional</b>",
                      tituloAlerta: "Atualizado",
                    },
                  });
                } else {
                  const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                    disableClose: true,
                    data: {
                      textoAlerta:
                        "Ocorreu um erro ao editar seu perfil. Tente novamente",
                      iconAlerta: "warning",
                    },
                  });
                }
              },
              (error) => {
                this.hideCL = true;
                const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                  disableClose: true,
                  data: {
                    textoAlerta:
                      "Verifique sua conexão com a internet. Tente novamente",
                    iconAlerta: "warning",
                  },
                });
              }
            );
          } else {
            this.userAsPro = false;
          }
        } else {
          this.userAsPro = false;
        }
      });
    } else {
      //desativando, só enviar pro servidor
      let customParams = {
        //lista: localStorage.getItem('turboCart'),
        email: this.tmaService.hcEmail,
        senha: this.tmaService.hcSenha,
        profissional: false,
        profissoes: "",
      };
      this.hideCL = false;
      this.tmaService.editarTipoPerifl(customParams).subscribe(
        (qRes) => {
          this.hideCL = true;
          console.log(qRes);
          if (qRes["res"] == "done") {
            this.tmaService.hcIsPro = false;
            const perfilChan = this.dialog.open(AlertaSimplesDialog, {
              disableClose: true,
              data: {
                textoAlerta: "Tipo de Perfil atualizado com sucesso!",
                tituloAlerta: "Atualizado",
              },
            });
          } else {
            const erroCriar = this.dialog.open(AlertaSimplesDialog, {
              disableClose: true,
              data: {
                textoAlerta:
                  "Ocorreu um erro ao editar seu perfil. Tente novamente",
                iconAlerta: "warning",
              },
            });
          }
        },
        (error) => {
          this.hideCL = true;
          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: {
              textoAlerta:
                "Verifique sua conexão com a internet. Tente novamente",
              iconAlerta: "warning",
            },
          });
        }
      );
    }
  }

  changeT(qParametro: any, qValor: any) {
    console.log(qParametro);
    //enviar isso diretamente pro servidor?
    if (qParametro == "cidade") {
      this.minhasPreferencias["ExibirCidadeUF"] = !qValor;
    }
    if (qParametro == "peso") {
      this.minhasPreferencias["ExibirPeso"] = !qValor;
    }
    if (qParametro == "altura") {
      this.minhasPreferencias["ExibirAltura"] = !qValor;
    }

    if (qParametro == "notificacaochat") {
      this.minhasPreferencias["NotificacoesChat"] = !qValor;
    }

    if (qParametro == "perfil") {
      this.minhasPreferencias["AceitaSeguidores"] = !qValor;
    }

    this.salvarPref(qParametro, !qValor);
  }

  salvarPref(qParametro: any, qValor: any): void {
    this.hideCL = false;
    var dadosIn =
      "email=" +
      this.tmaService.hcEmail +
      "&senha=" +
      this.tmaService.hcSenha +
      "&parametro=" +
      qParametro +
      "&valor=" +
      qValor;
    this.tmaService.eDitarPref(dadosIn).subscribe((qRes) => {
      this.hideCL = true;
      console.log(qRes);
      if (qRes["res"] == "done") {
        if (qParametro == "dieta" || qParametro == "treino") {
          this.obterPreferencias();
        }
      }
    });
  }

  openBS(tipoBs: any, valorIn: any): void {
    //buscar a lista no servidor e passar para o bs
    this.hideCL = false;
    var gDados =
      "email=" + this.tmaService.hcEmail + "&senha=" + this.tmaService.hcSenha;
    var meusItens = [];

    if (tipoBs == "dieta") {
      this.tmaService.listarDietas(gDados).subscribe((qRes) => {
        console.log(qRes);
        this.hideCL = true;
        if (qRes["res"] == "done") {
          meusItens = qRes["arrDietas"];
          this.mBottomCfg = this.bottomSheet.open(BottomSheetOverviewCfg, {
            data: { arrItens: meusItens, tipo: tipoBs, valorAtual: valorIn },
          });
          this.mBottomCfg.afterDismissed().subscribe((res) => {
            console.log("bottom dismiss");
            console.log(res);
            if (res != null) {
              if (res != valorIn) {
                //enviar pro servidor atualizar
                this.tmaService.hcDietaFix = res;
                this.salvarPref("dieta", res);
              }
            }
          });
        }
      });
    }
    if (tipoBs == "treino") {
      this.tmaService.listarTreinos(gDados).subscribe((qRes) => {
        console.log(qRes);
        this.hideCL = true;
        if (qRes["res"] == "done") {
          meusItens = qRes["arrTreinos"];
          this.mBottomCfg = this.bottomSheet.open(BottomSheetOverviewCfg, {
            data: { arrItens: meusItens, tipo: tipoBs, valorAtual: valorIn },
          });
          this.mBottomCfg.afterDismissed().subscribe((res) => {
            console.log("bottom dismiss");
            console.log(res);
            if (res != null) {
              if (res != valorIn) {
                //enviar pro servidor atualizar
                this.tmaService.hcTreinoFix = res;
                this.salvarPref("treino", res);
              }
            }
          });
        }
      });
    }
  }

  voltar(): void {
    //this._location.back();
    if (this.tmaService.gUrlAnterior == "me/perfil") {
      this.router.navigate(["/me/perfil"]);
    } else {
      this.router.navigate(["/home"]);
    }
  }

  removerPerfil() : void {
    const excluirConta = this.dialog.open(AlertaConfirmDialog, {
      //width: '250px',
      disableClose: true,
      data: {iconAlerta: "delete_forever", tituloAlerta: "Excluir", textoAlerta: "A exclusão de uma conta é um processo irreversível, tem certeza que deseja fazer isso?", textoCancel: 'Não', textoConfirm: "SIM"}
    });

    excluirConta.afterClosed().subscribe(result =>{
      console.log(result);
      if(result) {
        //server side
        let customParams = {
          email: this.tmaService.hcEmail,
          senha: this.tmaService.hcSenha,
        };

        this.hideCL = false;
        this.tmaService.excluirConta(customParams).subscribe((qRes) =>{
          this.hideCL = true;
          console.log(qRes);
          if(qRes['res'] == 'ok') {
            if(this.tmaService.forceLogout().valueOf() == true){
              this.router.navigate(['/inicio']);
            }
          }
          else {
            const erroCriar = this.dialog.open(AlertaSimplesDialog, {
              disableClose:true,
              data: {textoAlerta: "Ocorreu um erro ao excluir sua conta. Tente novamente", iconAlerta: 'warning'}
            });
          }
        },
        (error) =>{
          this.hideCL = true;

          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose:true,
            data: {textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning'}
          });
        })
       
        // this.router.navigate(['/dashboard/add-treino/' + this.nickPaciente + '/' + this.idPlano ]);
      }
    })


  }

}

@Component({
  selector: "bottom-sheet-cfg",
  templateUrl: "bottom-sheet-cfg.html",
  styleUrls: ["./bottom-sheet-cfg.css"],
})
export class BottomSheetOverviewCfg {
  refeicaoAtual: any = "";
  tipoNotify: any = "";
  frasediaSemana: any = "";
  opDesativar: any = "";
  opAtivar: any = "";
  arrItens: any[] = [];
  tipoExib: any = "";
  itenFavorito: any = "";
  changeType: boolean = false;
  Nutricionista: boolean = false;
  Treinador: boolean = false;
  Fisioterapeuta: boolean = false;
  Medico: boolean = false;
  Coach: boolean = false;
  arrPros: any[] = [];

  constructor(
    private bottomSheetRef: MatBottomSheetRef<BottomSheetOverviewCfg>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    public dialog: MatDialog,
    public tmaService: TamasAlunoService
  ) {}
  ngOnInit() {
    console.log(this.data);
    this.arrItens = this.data.arrItens;
    this.tipoExib = this.data.tipo;
    this.itenFavorito = this.data.valorAtual;
    if (this.data.TP) {
      this.changeType = true;
    }
  }
  salvarTD(): void {
    if (this.changeType) {
      var txtProfs = "";
      if (this.Nutricionista) txtProfs += "Nutricionista,";
      if (this.Treinador) txtProfs += "Educador Físico,";
      if (this.Fisioterapeuta) txtProfs += "Fisioterapeuta,";
      if (this.Medico) txtProfs += "Médico,";
      if (this.Coach) txtProfs += "Coach,";

      this.bottomSheetRef.dismiss(txtProfs);
    } else {
      this.bottomSheetRef.dismiss(this.itenFavorito);
    }
  }

  changesNotify(): void {
    console.log(this.opDesativar, this.opAtivar);
    if (this.tipoNotify == "ativar") {
      this.bottomSheetRef.dismiss(this.opAtivar);
    } else {
      this.bottomSheetRef.dismiss(this.opDesativar);
    }
  }


}
